'use strict';

var alphanumericPattern = /^[a-z0-9]+$/i;
var textPattern = /^[a-z0-9\s_*%\-.@$!&+=?:;,'#()/]+$/i;

// email address regex source: https://stackoverflow.com/a/1373724
var emailAddressPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

// url regex source: http://stackoverflow.com/questions/11809631
// eslint-disable-next-line no-useless-escape
var urlPattern = /^(https?\:\/\/*)?(['+,|!"£$%&\/()=?^*ç°§;:_>\] \[@);{}])?([^'+,|!"£$%&\/()=?^*ç°§;:_>\] \[@);{}]{1,63}\.[A-Za-z0-9]{2,63})(\/?.*)$/i;

var googleAnalyticsIdPatternUA = /^UA-\d+-\d+$/i;
var googleAnalyticsIdPatternG = /^G-[A-Z0-9]+/i;

var reservedWords = ['godaddy', 'go daddy', 'gocladdy', 'wildwestdomains', 'wild west domains', 'bluerazor', 'blue razor', 'maddog', 'mad dog', 'starfield'];

module.exports = {
  alphanumeric: function alphanumeric(string) {
    return alphanumericPattern.test(string);
  },

  text: function text(string) {
    return textPattern.test(string);
  },

  emailAddress: function emailAddress(string) {
    return emailAddressPattern.test(string);
  },

  googleAnalyticsId: function googleAnalyticsId(string) {
    return googleAnalyticsIdPatternUA.test(string) || googleAnalyticsIdPatternG.test(string);
  },

  hostname: function hostname(site, allowProtocol, allowPath) {
    var groups = urlPattern.exec(site);

    if (!groups || groups[2]) {
      return false;
    }
    if (!allowProtocol && groups[1]) {
      return false;
    }
    if (!allowPath && groups[4]) {
      return false;
    }

    return {
      protocol: groups[1],
      domain: groups[3],
      path: groups[4]
    };
  },

  url: function url(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var token = this.hostname(value, true, true);

    return token && (!options.requireProtocol || !!token.protocol);
  },

  safeName: function safeName(string) {
    return !reservedWords.map(function (w) {
      return new RegExp(w.replace(/(\W)/g, '\\$1'), 'gi');
    }).reduce(function (outcome, wordExp) {
      if (wordExp.test(string)) {
        return true;
      }

      return outcome;
    }, false);
  }
};